import { ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/ui/reveal';
import { CtaButton } from './cta-button';

/**
 * Ft6 Letter close · roman signoff · width ~50ch · closing hairline.
 * The page's single dark moment, and it belongs here. No grid texture —
 * the ink band is the contrast.
 */
export function FinalCta() {
  return (
    <section className="bg-primary text-primary-foreground">
      <Reveal className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:py-28">
        <div className="max-w-2xl">
          <h2 className="type-wonk font-display text-3xl font-medium leading-tight tracking-tight text-primary-foreground [overflow-wrap:anywhere] md:text-5xl">
            Stop wondering what's happening to your land.
          </h2>
          <p className="mt-6 max-w-md leading-relaxed text-primary-foreground/65">
            Start today, First report within 7 business days.
          </p>
          <div className="mt-10 border-t border-primary-foreground/20 pt-8">
            <CtaButton location="final_cta" variant="paper" depth="3d" className="w-full sm:w-auto">
              Start Monitoring
              <ArrowRight className="size-4" />
            </CtaButton>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
